import { AccordionTableRow } from "components/dynamic-table/accordion-table-row";
import { InnerRowRenderProps } from "components/dynamic-table/color-table";
import { Box, Flex, Text } from "@chakra-ui/react";
import { EquipeVendaRowProps } from "../utils";
import { PersonIcon } from "components/vectors/menu-icons/person-icon";

interface UserItem {
  name: string;
  value: number;
  isVendeAI: boolean;
}

interface AccordionEquipeRowProps extends InnerRowRenderProps {
  activeIndex: number | undefined;
  row: EquipeVendaRowProps;
  users?: UserItem[];
}

export function AccordionEquipeRow({
  columnsLength,
  rowIndex,
  row,
  activeIndex,
  users
}: AccordionEquipeRowProps) {
  return (
    <AccordionTableRow
      key={row.id || rowIndex}
      columnsLength={columnsLength}
      index={rowIndex}
      activeIndex={activeIndex}
    >
      <Box p="10px 24px" w="100%" bg="gray.50">
        <Text fontSize="14px" fontWeight="medium" mb="8px">
          Vendedores na equipe
        </Text>
        <Flex flexWrap="wrap" gap="8px">
          {row.usersIds?.map((id) => {
            const selectedUser = users!.find(({ value }) => value === id);
            return (
              <Flex
                key={id}
                alignItems="center"
                border="1px solid var(--chakra-colors-custom-gray)"
                h="32px"
                borderRadius="10px"
                p="4px 10px"
                fontWeight="medium"
              >
                <Box mr="8px" borderRadius="full" p="3px" bg="gray.200">
                  <PersonIcon width="14px" height="14px" />
                </Box>
                {selectedUser?.name}
              </Flex>
            );
          })}
        </Flex>
      </Box>
    </AccordionTableRow>
  );
}
